import React, { Fragment } from 'react'
import { PageHeader } from '@retailer-platform/shared-components'
import { Breadcrumb } from '@retailer-platform/shared-components'
import { useDomainMessage } from 'domains/collections/utils/domain/intl'
import { CollectionsForm } from 'domains/collections/components/collections-form/CollectionsForm'
import { CollectionsFormMode } from 'domains/collections/components/collections-form/utils/collectionsForm.types'
import { type CollectionsRoutingConfig } from 'domains/collections/types/collections.types'
import { CollectionsBreadcrumbs } from 'domains/collections/components/breadcrumbs/CollectionsBreadcrumbs'
import { type CollectionTypeEnum } from 'domains/collections/api'
import { useDomainGoToPath } from 'domains/collections/utils/domain/routing'

export interface CollectionsEditProps {
  collectionId: string
  retailerId?: string
  routingConfig: CollectionsRoutingConfig
  collectionType: CollectionTypeEnum
}

export const CollectionsEdit: React.FunctionComponent<CollectionsEditProps> = ({
  retailerId,
  collectionId,
  routingConfig,
  collectionType,
}) => {
  const formModeDetails = {
    formMode: CollectionsFormMode.Update,
    retailerId,
    collectionId,
  } as const

  const goToCollectionList = useDomainGoToPath(routingConfig.list)

  const editMessage = useDomainMessage('collectionsDomain.breadcrumb.edit')

  return (
    <Fragment>
      <PageHeader
        addBottomPadding
        title={
          <CollectionsBreadcrumbs routingConfig={routingConfig}>
            <Breadcrumb>{editMessage}</Breadcrumb>
          </CollectionsBreadcrumbs>
        }
      />
      <CollectionsForm
        goToCollectionList={goToCollectionList}
        formModeDetails={formModeDetails}
        retailerId={retailerId}
        collectionType={collectionType}
      />
    </Fragment>
  )
}
